/* 订阅提交时保留当前页面和查询参数，并回到触发提交的 Section。 */
if (!window.bixdoOralEmailCaptureInitialized) {
  window.bixdoOralEmailCaptureInitialized = true;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.bixdo-oral-email__form');

    if (!form) {
      return;
    }

    const returnToInput = form.elements.namedItem('return_to');

    if (returnToInput) {
      returnToInput.value = `${window.location.pathname}${window.location.search}#${form.id}`;
    }
  });
}
